module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c02-15b47865ad45e020de277f0350d2ec89.jpg";